import { VueModule } from '@Foundation/utilities';
import VideoPlayer from './code/Scripts/components/video-player.vue';

export default VueModule({
  components: {
    VideoPlayer
  }
});
